import { Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FundDetails, FundPriceChart, FundType, MutualFund } from 'src/app/models/mutualFund';
import { UrlConstants } from 'src/app/models/urlConstants';
import { FundService } from 'src/app/services/fund.service';
import { SystemSettingsService } from 'src/app/services/systemSettings.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-mutual-fund',
  templateUrl: './mutual-fund.component.html',
  styleUrls: ['./mutual-fund.component.scss']
})
export class MutualFundComponent implements OnInit {

  lang: string;
  isDarkTheme: boolean;
  selected: boolean=false;
  isEGID = UrlConstants.isEGID;
  mutualFundList: MutualFund[] = null;
  selectedFund: MutualFund;
  fundDetails: FundDetails;  
  fundPriceChartData: FundPriceChart;
  fundTypes: FundType[];
  selectedFundType: number=0;
  readonly ALLOW_MUTUAL_FUND= "AllowMutualFund";

  constructor(
    public translate: TranslateService,
    public fundService: FundService,
    public settingsService: SystemSettingsService,
    private router: Router
  ) { 
    this.lang = this.translate.currentLang
    this.isDarkTheme = localStorage.getItem("darktheme") == "dark" ? true : false;
  }

  ngOnInit(): void {
    this.getMutualFundList(this.selectedFundType);
    this.fundService.getFundTypes().subscribe((types) => {this.fundTypes = types;});
    this.settingsService.checkSetting(this.ALLOW_MUTUAL_FUND).subscribe(isAllowed => {
      if (!isAllowed) {
        this.router.navigate(["/"]);
      }
    }, error => {
    });
  }

  saveTabState(event: any, fundId: number) {
    this.selectedFundType = fundId;
    let id = event.target.attributes.id;
    var tabs = document.querySelectorAll('.types-tab');
    tabs.forEach(i => i.classList.remove('types-tab-active'));
    let element = document.getElementById(id.value);
    element?.classList.add('types-tab-active');
    this.getMutualFundList(this.selectedFundType);
  }


  getMutualFundList(selectedFundType: number) {
    this.fundService.getMutualFundList(null,selectedFundType).subscribe(({ funds, selectedFund }) => {
      this.mutualFundList = funds;
      this.selectedFund = selectedFund;

      if (this.selectedFund) {
        this.getMutualFundDetails(this.selectedFund.SymbolCode);
        this.getFundPriceHistory(this.selectedFund.SymbolCode);
  }})
};


getMutualFundDetails(symbolCode: string) {
  this.fundService.getMutualFundDetails(symbolCode).subscribe((details) => {
    if(details){
      this.fundDetails = details;
      if (this.fundDetails.PdfsUrls) {
        this.fundDetails.PdfsUrlsList = this.fundDetails.PdfsUrls.split(",")
      }
    } else {
      this.fundDetails = null
    }
  });
}

getFundPriceHistory(symbolCode: string) {
  this.fundService.getFundPriceHistory(symbolCode).subscribe((chartData) => {
    this.fundPriceChartData = chartData;
  });
}

  selectFund(selectedFund: MutualFund){
    this.selectedFund = selectedFund;
    this.mutualFundList = this.mutualFundList.map(fund => ({
        ...fund,
        selected: fund.SymbolCode === selectedFund.SymbolCode
      }));
      this.getMutualFundDetails(selectedFund.SymbolCode)
      this.getFundPriceHistory(selectedFund.SymbolCode)
  }
}
